import { ExpectedProps, ServerPropsFactory } from '@lib/factory/serverprops';
import { LinksEnum } from '@specs/navigation';
import { useRouter } from 'next/router';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { Modals } from '@components/Pages/ExplorePage/Modals/Modals';
import { NextPage } from 'next';
import { PageLayout } from '@components/PageLayout/PageLayout';
import { ToysPrivateList } from '@components/Pages/FeedPage/ToysLists/ToysPrivateList';
import { ToysPublicList } from '@components/Pages/FeedPage/ToysLists/ToysPublicList';
import React from 'react';
import { Search } from '@components/UIKit/Search/Search';
import { Sorting } from '@components/Pages/FeedPage/Sorting';
import cn from 'classnames';
import s from '../explorePage.module.scss';
import { useSession } from 'next-auth/react';
import { useTranslation } from '@hooks/useTranslation';
import { FilterToysRaritySelect } from '@components/Pages/ExplorePage/FilterToysRaritySelect/FilterToysRaritySelect';
import { Breadcrumb } from '@components/UIKit/Breadcrumb/Breadcrumb';
import { TabItems } from '@components/Pages/ExplorePage/TabItems';
import { ToysCount } from '@components/Pages/ExplorePage/ToysCount/ToysCount';
import { PhysicalToysList } from '@components/Pages/FeedPage/ToysLists/PhysicalToysList';

// Без getServerSideProps после обновления страницы удаляются квери параметры поиска
export const getServerSideProps = ServerPropsFactory(async (props: ExpectedProps) => ({
  ...props
}));
interface PageProps extends ExpectedProps {}
const Page: NextPage<PageProps> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    status
  } = useSession();
  const router = useRouter();
  return <>
            <PageLayout data-sentry-element="PageLayout" data-sentry-source-file="index.tsx">
                <div className={s.explorePage}>
                    <div className={cn(s.explorePage__container, '_container')}>
                        <Breadcrumb data-sentry-element="Breadcrumb" data-sentry-source-file="index.tsx" />
                        <div className={s.explorePage__top}>
                            <div className={s.explorePage__head}>
                                <h1 className={cn(s.explorePage__title, '_title')}>
                                    {tr({
                  id: 'feed.page.feed.tab.toys'
                })}
                                </h1>
                                <ToysCount isPhysicalPage={router.pathname === LinksEnum.EXPLORE_TOYS_PHYSICAL} data-sentry-element="ToysCount" data-sentry-source-file="index.tsx" />
                            </div>
                            <div className={s.explorePage__tabs}>
                                <TabItems data-sentry-element="TabItems" data-sentry-source-file="index.tsx" />
                            </div>
                            {router.pathname === LinksEnum.EXPLORE_TOYS && <Search boxClassName={s.explorePage__search} placeholder={tr({
              id: 'feed.page.toys.placeholder'
            })} name={'toys'} />}
                        </div>
                        {router.pathname === LinksEnum.EXPLORE_TOYS && <>
                                <div className={s.explorePage__sorting}>
                                    <FilterToysRaritySelect />
                                    <Sorting className={s.explorePage__sorting__sortItem} />
                                </div>
                                {status === 'authenticated' ? <ToysPrivateList /> : status === 'unauthenticated' ? <ToysPublicList /> : <LogoLoader />}
                            </>}
                        {router.pathname === LinksEnum.EXPLORE_TOYS_PHYSICAL && <PhysicalToysList />}
                    </div>
                </div>
            </PageLayout>
            <Modals data-sentry-element="Modals" data-sentry-source-file="index.tsx" />
        </>;
};
export default Page;